import { IAugmentedJQuery, IComponentOptions, IController, IDocumentService, IScope } from 'angular';
import { RoleService } from '../../../../core/services/role/role.service';
import { IRawRole } from '../../../../core/services/role/role.interfaces';
import { $Event } from '../../../../helpers';
import { checkInsideClick } from '../../../../helpers/check-inside-click';
import './register-as.component.scss';

interface IPopupInfo {
  title: string;
  text: string;
  lists: string[][];
}

interface IRolesData {
  roleInfos: {
    [key: string]: string[]
  };
  popupInfos: {
    [key: string]: IPopupInfo;
  };
}

export class RegisterAsController implements IController {
  static $inject = [
    '$scope',
    '$document',
    '$element',
    'RoleService'
  ];
  roleSelected: ($event) => void;
  // roles: IRawRole[];
  roles: IRawRole;
  group: IRawRole;
  popupInfo: IPopupInfo;
  isOpened = false;
  selectedRole: IRawRole = {};
  roleInfo: string[];
  rolesData: IRolesData;

  selectRoleReg: string;

  initialRoles: IRawRole[];

  private $selectWrapper;




  constructor(private $scope: IScope,
    private $document: IDocumentService,
    private $element: IAugmentedJQuery,
    private roleService: RoleService) {
  }

  $onInit() {
    this.initData();
    this.$selectWrapper = this.$element.find('.select-wrapper');
    this.initOutsideClickListener();
    this.initialRoles = this.roleService.roles;
    this.group = this.initialRoles.find(item => item.name == this.selectRoleReg);
  }

  selectRole(event, role: IRawRole) {
    let group = this.group;
    this.roleInfo = this.rolesData.roleInfos[group.id];
    this.selectedRole = role;
    this.roleSelected(new $Event({ role, group }));
    this.isOpened = false;
  }

  toggleSelect() {
    this.isOpened = !this.isOpened;
  }

  showPopupInfo(role) {
    this.popupInfo = this.rolesData.popupInfos[role.id];
  }

  hidePopupInfo() {
    this.popupInfo = null;
  }

  private initOutsideClickListener() {
    this.$document.on('click', (event) => {
      if (!this.isOpened) {
        return;
      }
      if (!checkInsideClick(this.$selectWrapper[0], event)) {
        this.$scope.$apply(() => {
          this.isOpened = false;
        });
      }
    });
  }

  private initData() {
    this.rolesData = {
      roleInfos: {
        1: [
          'Please fill in your Name and Personal e-mail address to add to the "White list"',
          'We will inform you in advance about the launch of the "GMC Business Center"'
        ],
        2: [],
        3: ['You may pass the registration as a legal entity or a physical person with the same access to project functionality']

      },
      popupInfos: {
        21: {
          title: 'Onshore',
          text: 'When choosing "Onshore" make sure that your position is included in the Job Type list:',
          lists: [
            [
              'Shipping',
              'Maritime Services',
              'Ship Building And Repair',
              'Maritime Education And Training',
              'Port And Terminals',
              'Offshore Wind'
            ]
          ]
        },
        22: {
          title: 'Seafarer',
          text: 'When choosing "Seafarer" make sure that your position is included in the Vessel Type list:',
          lists: [
            ['Bulk Carrier',
              'Container Carrier',
              'Tanker',
              'Liquefied Gas Carrier',
              'General / Dry Cargo',
              'Auto Carrier',
              'Refrigerated Vessel',
              'Cruise/Passenger Vessel',
              'Heavy Lift / Project Cargo Vessel',
              'Fishing Vessel'
            ],
            [
              'Specialized Vessel',
              'Coastal Vessel',
              'Floating Dock',
              'Subsea / ROV / Diving Vessel',
              'Offshore Support Vessel',
              'Barges',
              'Cable / Pipe Layer Vessel',
              'Construction Vessel',
              'Wind Farm Vessel',
              'Dredger'
            ]

          ]
        },
        23: {
          title: 'Oil & Gas',
          text: 'When choosing "Oil & Gas" make sure that your position is included in the Job/Vessel Type list:',
          lists: [
            [
              'Oil & Gas Companies',
              'Oil & Gas Service Companies',
              'Offshore Rig / Platform',
              'Land Drilling Rig',
              'Drillship',
              'FPSO/FSO',
              'Shuttle Tanker'
            ]
          ]
        },
        31: {
          title: 'Company',
          text: 'Сhoose this category if you belong to:',
          lists: [
            [
              'Ship owner',
              'Ship operator',
              'Industrial company'
            ]
          ]
        }
      }
    };
  }
}

export const RegisterAsMobileComponent: IComponentOptions = {
  controller: RegisterAsController,
  template: require('./register-as.component.html'),
  bindings: {
    roleSelected: '&',
    selectRoleReg: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states_mobile/auth/components/register-as/register-as.component.ts